import { useStateMachine } from "little-state-machine";
import { Link, useNavigate } from "react-router-dom";
import { RoutePathsEnum } from "infrastructure/RoutePathsEnum";
import ISiteDiaryItemOrderViewModel from "interfaces/SiteDiary/ItemOrder/ISiteDiaryItemOrderViewModel";
import { PencilSquare } from "react-bootstrap-icons";
import { RolesEnum } from "modules/rolesEnum";
import { ItemOrderStatusEnum } from "modules/ItemOrderStatusEnum";
import { updateEditItemOrderPageOrigination } from "actions/updateEditItemOrderPageOrigination";
import IEditItemOrderRequestModel from "interfaces/Request/IEditItemOrderRequestModel";

const EditTemplate = (props: ISiteDiaryItemOrderViewModel): any => {
  const { state, actions } = useStateMachine({ updateEditItemOrderPageOrigination });

  const {
    id, orderType, item, recipient, quantity, size, status, hwrcSiteId, diaryDate
  } = props;

  const canEdit = [ItemOrderStatusEnum.Raised.toString(), ItemOrderStatusEnum.Actioned.toString()].includes(status)
   || [RolesEnum.SuperAdmin, RolesEnum.Admin].includes(state.userRole!);

  const editData : IEditItemOrderRequestModel = {
    id,
    hwrcSiteId,
    orderType,
    item,
    recipient,
    quantity,
    size,
    status
  };

  const editUrl = encodeURI(`${RoutePathsEnum.ItemOrdersEdit}/${hwrcSiteId}/${diaryDate}`);

  const handleContextMenu = (event:any) => {
    event.preventDefault();
  };

  const handleNavigate = () => {
    actions.updateEditItemOrderPageOrigination(RoutePathsEnum.SiteDiaryLandingPage);
  };

  return (
    <>
      {canEdit && (
        <Link data-testid="itemOrderEditButton" state={editData} to={editUrl} onClick={handleNavigate} onContextMenu={handleContextMenu}>
          <PencilSquare color="#000" />
          <span className="visually-hidden">
            {`Edit ${item} item order`}
          </span>
        </Link>
      )}
    </>
  );
};
export default EditTemplate;
